module.exports = __webpack_public_path__ + "static/media/1_FeiTcE7xAIKhNrRa-2_oiQ.824134b4.png";